import React from "react";
import { Box } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { classOptions, equipmentConditions, equipmentYears, makeOptions } from "modules/equipment";
import { FormSectionHeader, equipmentMileageFormatter } from "modules/desking";
import { CurrencyInputField, InputField, SelectField } from "components/form";
import { FinanceProgramFormValues, FormSectionProps } from "modules/desking/types";
import { StartDealRenderProps } from "../types";

type Props = FormSectionProps & StartDealRenderProps;

export const EquipmentSection = ({ sectionName }: Props) => {
  const { control } = useFormContext<FinanceProgramFormValues>();

  return (
    <Box className="section">
      <FormSectionHeader name="Equipment" sectionName={sectionName} />

      <Box className="sectionFields">
        <Box className="row">
          <InputField label="Quantity" control={control} name="equipment.quantity" />

          <SelectField label="Year" control={control} name="equipment.year" options={equipmentYears} />

          <SelectField label="Make" control={control} name="equipment.make" options={makeOptions} />

          <InputField label="Model" control={control} name="equipment.model" />

          <SelectField label="Class" control={control} name="equipment.class" options={classOptions} />

          <InputField control={control} label="Serial/VIN#" name="equipment.serialNumberVin" />
        </Box>

        <Box className="row">
          <InputField label="Stock Id" control={control} name="equipment.stockId" />

          <SelectField label="Condition" control={control} name="equipment.newUsed" options={equipmentConditions} />

          <InputField
            label="Mileage"
            control={control}
            name="equipment.mileage"
            formatter={value => equipmentMileageFormatter(value, "toUpdate")}
          />

          <InputField control={control} label="Description" name="equipment.description" />

          <CurrencyInputField control={control} label="Wholesale Cost" name="equipment.totalWholesaleCost" />

          <CurrencyInputField label="Retail Price" control={control} name="equipment.retailPrice" />
        </Box>
      </Box>
    </Box>
  );
};
